/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpGameBoard } from './FuelUpGameBoard';
import {
    FuelUpGameBoardFromJSON,
    FuelUpGameBoardFromJSONTyped,
    FuelUpGameBoardToJSON,
    FuelUpGameBoardToJSONTyped,
} from './FuelUpGameBoard';

/**
 * 
 * @export
 * @interface ActiveBoardResponse
 */
export interface ActiveBoardResponse {
    /**
     * 
     * @type {FuelUpGameBoard}
     * @memberof ActiveBoardResponse
     */
    board: FuelUpGameBoard;
    /**
     * True if the requested loop level does not have an active board configured yet
     * @type {boolean}
     * @memberof ActiveBoardResponse
     */
    loopNotConfigured?: boolean;
    /**
     * The loop level that was requested
     * @type {number}
     * @memberof ActiveBoardResponse
     */
    requestedLoopLevel?: number;
}

/**
 * Check if a given object implements the ActiveBoardResponse interface.
 */
export function instanceOfActiveBoardResponse(value: object): value is ActiveBoardResponse {
    if (!('board' in value) || value['board'] === undefined) return false;
    return true;
}

export function ActiveBoardResponseFromJSON(json: any): ActiveBoardResponse {
    return ActiveBoardResponseFromJSONTyped(json, false);
}

export function ActiveBoardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveBoardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'board': FuelUpGameBoardFromJSON(json['board']),
        'loopNotConfigured': json['loopNotConfigured'] == null ? undefined : json['loopNotConfigured'],
        'requestedLoopLevel': json['requestedLoopLevel'] == null ? undefined : json['requestedLoopLevel'],
    };
}

export function ActiveBoardResponseToJSON(json: any): ActiveBoardResponse {
    return ActiveBoardResponseToJSONTyped(json, false);
}

export function ActiveBoardResponseToJSONTyped(value?: ActiveBoardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'board': FuelUpGameBoardToJSON(value['board']),
        'loopNotConfigured': value['loopNotConfigured'],
        'requestedLoopLevel': value['requestedLoopLevel'],
    };
}

